















import Vue from 'vue';
import StepContent from '@/components/StepContent.vue';
import BackgroundTools from '@/components/BackgroundTools.vue';

export default Vue.extend<any, any, any, any>({
	props: {
		cut: {
			type: Boolean,
			default: false,
		},
		head: {
			type: Boolean,
			default: false,
		},
		stitches: {
			type: Boolean,
			default: false,
		},
	},
});
